export default __webpack_public_path__ + "static/media/credit-card.f6a2a312.svg";